window.UserApplicationsAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    // Constants [apps status]
    self.APP_ALL = 'all';
    self.APP_ACTIVE = 'active';
    self.APP_DRAFT = 'draft';
    self.APP_APPLIED = 'applied';
    self.APP_ARCHIVE = 'archived';
    self.ON_BOARDING = 'onBoarding';
    self.SCREENING_QUESTIONS = 'SCREENING_QUESTIONS';

    // Constants [apps sub status]
    self.IN_INTERVIEW = 'interview';
    self.INVITED = 'invited';
    self.UNREAD = 'unread';

    self.archive = function(applicationId) {
        var deferred = $q.defer();
        if (!applicationId) {
            var error = "Calling archive with application id: " + applicationId;
            deferred.reject(error);
        }
        else {
            _protected.request('user_applications/archive', 'POST', {id: applicationId}).then(function(res) {
               deferred.resolve(res);
            });
        }

        return deferred.promise;
    };

    self.loadApps = function() {
        var deferred = $q.defer();

        _protected.request('user_applications', 'GET').then(function(res) {
            if (res && res.data && res.data.data) {
                var applications = res.data.data;
                deferred.resolve(applications);
            }
        });

        return deferred.promise;
    };

    self.loadAppDetails = function(appId) {
        var deferred = $q.defer();

        _protected.request('user_application_details/' + appId, 'GET').then(function(res){
            deferred.resolve(res.data);
        });

        return deferred.promise;
    }

    self.getScreeningQuestionsInvitations = function (payload) {
        var defer = $q.defer();

        _protected.request('candidates/applications/screening_forms', 'GET', payload)
            .then(function(res){
                if (res.data && res.data.status_code == 200 && res.data.data) {
                    defer.resolve(res.data.data['screening_forms']);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

});
